// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"Cd","landingPageVideo":"Dd","play":"Ed","iframeVideo":"Fd","playHidden":"Gd","fullwidth":"Hd"};